import { render } from "./BoothIntro.vue?vue&type=template&id=c2d76f4c"
import script from "./BoothIntro.vue?vue&type=script&lang=js"
export * from "./BoothIntro.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__